export const AppReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_DATA":
      return {
        ...state,
        photos: [...action.payload],
      };
    default:
      return state;
  }
};
